import React, { useState } from 'react';
import { Modal, Tabs, Form } from 'antd';
import Prescribed from './Tabs/Prescribed';
import Otc from './Tabs/Otc';

function PopUp({ visible, onClose, data, UserID, past, patch, idPrescription, ConditionName, setFlagFetch, userIdPast }) {
    const [localFlag, setLocalFlag] = useState(0);
    const [resetFlag, setResetFlag] = useState(0);
    const [activeKey, setActiveKey] = useState("Prescribed");
    const [prescribedForm] = Form.useForm();
    const [otcForm] = Form.useForm();

    const updateFlags = () => {
        setLocalFlag((prev) => prev + 1);
        setFlagFetch((prev) => {
            console.log("Previous flagFetch:", prev);
            return prev + 1;
        });
    };

    const tabList = [
        {
            key: "Prescribed",
            label: <p style={{ fontSize: "20px", fontWeight: "500" }}>Prescribed</p>,
            children: <Prescribed form={prescribedForm} onClose={onClose} data={data} UserID={UserID ? UserID : userIdPast} past={past} patch={patch} idPrescription={idPrescription} ConditionName={ConditionName} setFlagFetch={updateFlags} resetFlag={resetFlag} />,
        },
        {
            key: "OTC",
            label: <p style={{ fontSize: "20px", fontWeight: "500" }}>OTC</p>,
            children: <Otc form={otcForm} onClose={onClose} data={data} UserID={UserID ? UserID : userIdPast} past={past} patch={patch} setFlagFetch={setFlagFetch} ConditionName={ConditionName} resetFlag={resetFlag} />,
        },
    ];

    const handleTabChange = (key) => {
        setActiveKey(key);
    };

    // Reset the form fields when the modal is closed
    const handleCancel = () => {
        setResetFlag((prev) => prev + 1);
        if (!data) {
            prescribedForm.resetFields();
            otcForm.resetFields();
        }
        onClose();
    };

    return (
        <Modal
            title="Add Prescription"
            open={visible}
            footer={null}
            closeIcon={<img src="/assets/images/close-circle.svg" alt="close" />}
            onCancel={handleCancel}
            width="50%"
            style={{ backgroundColor: "#F8F8F8", borderRadius: "12px", padding: "10px" }}
        >
            <Tabs
                activeKey={activeKey}
                onChange={handleTabChange}
                className="custom-tabs-popup"
                indicatorSize={0}
                items={tabList}
            />
        </Modal>
    );
}

export default PopUp;
